var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-salaries-bg-orange';
                    var viewUrl = 'sprite.svg#view-icon-salaries-bg-orange';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 52 63',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };